module.exports = __webpack_public_path__ + "static/media/watchlist-black.6f75a827.svg";